import React, { useEffect, useRef } from "react";
import { testId } from '../../../../utils/testIds';
import { useFormContext, useController } from "react-hook-form";
import { useSelector } from "react-redux";
import moment from "moment";
import CalendarPicker from "../CalendarPicker";
import Icon from "../../../../icons";
import get from "lodash/get";

const CALENDAR_VALUE_FORMAT = "MM/DD/YYYY, hh:mm A";

function DateWithTimezoneField({
  config,
  value,
  onChange,
  onBlur,
  disabled,
  required,
  error,
  renderMode,
}) {
  const { control } = useFormContext();

  const defaultTzPath = config?.fieldSettings?.path
  const defaultTzValue = config?.fieldSettings?.defaultValue
  const dateName = config?.fieldKey;
  const tzName = `${dateName}tz`;
  const userTz = useSelector((state) => 
    defaultTzPath
    ? get(state, defaultTzPath, '') : null
  )
  const tzList = useSelector(
    (state) => state?.sessionContextOidc?.tzData ?? []
  );
  const defaultTZ = tzList?.find(t => t.standard_time_zone === userTz || t.mapped_time_zone === userTz)
  const tzCtrl = useController({
    name: tzName,
    control,
    shouldUnregister: false,
    ...(defaultTzPath ? {defaultValue: defaultTZ?.id} : {defaultValue: defaultTzValue}),
  });

  const resolvedDefaultTz = defaultTzPath ? defaultTZ?.id : defaultTzValue;
  const currentTzValue = tzCtrl.field.value;
  const userEditedRef = useRef(false);

  useEffect(() => {
    if (resolvedDefaultTz && !userEditedRef.current && currentTzValue !== resolvedDefaultTz) {
      tzCtrl.field.onChange(resolvedDefaultTz);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resolvedDefaultTz, currentTzValue]);

  const selectedMoment = value ? moment(value) : null;
  const calendarValue = selectedMoment && selectedMoment.isValid()
    ? selectedMoment.format(CALENDAR_VALUE_FORMAT)
    : '';

  return (
    <div className={`formGroup mrNone${disabled ? ' disabled' : ''}`}>
      <div className="wth-4">
        <div className="activity-datewithtz-field">
          <div className="activity-datewithtz-date">
            <CalendarPicker
              dataTestPrefix={testId('field', config.fieldKey)}
              value={calendarValue}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled}
              required={required}
              error={error}
              minDate={moment().format('MM/DD/YYYY')}
              showTime
              placeholder={
                config?.fieldSettings?.placeholder ??
                config?.label ??
                "Due Date"
              }
            />
          </div>

          <select
            data-test={testId('field', config.fieldKey, 'timezone')}
            className={`activity-datewithtz-tz${disabled ? ' disabled' : ''}`}
            value={tzCtrl.field.value}
            onChange={(e) => {
              userEditedRef.current = true;
              tzCtrl.field.onChange(e.target.value);
            }}
            onBlur={tzCtrl.field.onBlur}
            disabled={disabled}
          >
            <option value="">Select timezone</option>

            {(tzList || []).map((tz) => (
              <option key={tz.id} value={tz.id}>
                {tz.display_value}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}

export default DateWithTimezoneField;